import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    straalOptions: [
      { value: 0, text: "+ 0 km" },
      { value: 1, text: "+ 1 km" },
      { value: 2, text: "+ 2 km" },
      { value: 5, text: "+ 5 km" },
      { value: 10, text: "+ 10 km" },
      { value: 15, text: "+ 15 km" },
      { value: 20, text: "+ 20 km" },
      { value: 30, text: "+ 30 km" },
      { value: 50, text: "+ 50 km" },
      { value: 100, text: "+ 100 km" },
    ],
    minPrijsOptions: [
      { value: 0, text: "€  0,-" },
      { value: 50000, text: "€ 50.000,-" },
      { value: 75000, text: "€ 75.000,-" },
      { value: 100000, text: "€ 100.000,-" },
      { value: 125000, text: "€ 125.000,-" },
      { value: 150000, text: "€ 150.000,-" },
      { value: 175000, text: "€ 175.000,-" },
      { value: 200000, text: "€ 200.000,-" },
      { value: 225000, text: "€ 225.000,-" },
      { value: 250000, text: "€ 250.000,-" },
      { value: 275000, text: "€ 275.000,-" },
      { value: 300000, text: "€ 300.000,-" },
      { value: 325000, text: "€ 325.000,-" },
      { value: 350000, text: "€ 350.000,-" },
      { value: 375000, text: "€ 375.000,-" },
      { value: 400000, text: "€ 400.000,-" },
      { value: 450000, text: "€ 450.000,-" },
      { value: 500000, text: "€ 500.000,-" },
      { value: 550000, text: "€ 550.000,-" },
      { value: 600000, text: "€ 600.000,-" },
      { value: 650000, text: "€ 650.000,-" },
      { value: 700000, text: "€ 700.000,-" },
      { value: 750000, text: "€ 750.000,-" },
      { value: 800000, text: "€ 800.000,-" },
      { value: 900000, text: "€ 900.000,-" },
      { value: 1000000, text: "€ 1000.000,-" },
      { value: 1250000, text: "€ 1250.000,-" },
      { value: 1500000, text: "€ 1500.000,-" },
      { value: 2000000, text: "€ 2000.000,-" },
    ],
    maxPrijsOptions: [
      { value: 50000, text: "€ 50.000,-" },
      { value: 75000, text: "€ 75.000,-" },
      { value: 100000, text: "€ 100.000,-" },
      { value: 125000, text: "€ 125.000,-" },
      { value: 150000, text: "€ 150.000,-" },
      { value: 175000, text: "€ 175.000,-" },
      { value: 200000, text: "€ 200.000,-" },
      { value: 225000, text: "€ 225.000,-" },
      { value: 250000, text: "€ 250.000,-" },
      { value: 275000, text: "€ 275.000,-" },
      { value: 300000, text: "€ 300.000,-" },
      { value: 325000, text: "€ 325.000,-" },
      { value: 350000, text: "€ 350.000,-" },
      { value: 375000, text: "€ 375.000,-" },
      { value: 400000, text: "€ 400.000,-" },
      { value: 450000, text: "€ 450.000,-" },
      { value: 500000, text: "€ 500.000,-" },
      { value: 550000, text: "€ 550.000,-" },
      { value: 600000, text: "€ 600.000,-" },
      { value: 650000, text: "€ 650.000,-" },
      { value: 700000, text: "€ 700.000,-" },
      { value: 750000, text: "€ 750.000,-" },
      { value: 800000, text: "€ 800.000,-" },
      { value: 900000, text: "€ 900.000,-" },
      { value: 1000000, text: "€ 1.000.000,-" },
      { value: 1250000, text: "€ 1.250.000,-" },
      { value: 1500000, text: "€ 1.500.000,-" },
      { value: 2000000, text: "€ 2.000.000,-" },
      { value: 0, text: "Geen maximum" },
    ],
    minWoonoppervlakteOptions: [
      { value: 0, text: "0 m²" },
      { value: 25, text: "25 m²" },
      { value: 50, text: "50 m²" },
      { value: 75, text: "75 m²" },
      { value: 100, text: "100 m²" },
      { value: 150, text: "150 m²" },
      { value: 250, text: "250 m²" },
      { value: 350, text: "350 m²" },
      { value: 500, text: "500 m²" },
      { value: 1000, text: "1000 m²" },
    ],

    maxWoonoppervlakteOptions: [
      { value: 25, text: "25 m²" },
      { value: 50, text: "50 m²" },
      { value: 75, text: "75 m²" },
      { value: 100, text: "100 m²" },
      { value: 150, text: "150 m²" },
      { value: 250, text: "200 m²" },
      { value: 350, text: "350 m²" },
      { value: 500, text: "500 m²" },
      { value: 1000, text: "1000 m²" },
      { value: 0, text: "Geen maximum" },
    ],
    soortenWoningOptions: [
      { value: "EENGEZINSWONING", text: "Eengezinswoning" },
      { value: "HERENHUIS", text: "Herenhuis" },
      { value: "VILLA", text: "Villa" },
      { value: "LANDHUIS", text: "Landhuis" },
      { value: "BUNGALOW", text: "Bungalow" },
      { value: "WOONBOERDERIJ", text: "Woonboerderij" },
      { value: "GRACHTENPAND", text: "Grachtenpand" },
      { value: "WOONBOOT", text: "Woonboot" },
      { value: "STACARAVAN", text: "Stacaravan" },
      { value: "WOONWAGEN", text: "Woonwagen" },
      { value: "LANDGOED", text: "Landgoed" },
    ],
    typenWoningOptions: [
      { value: "VRIJSTAANDE_WONING", text: "Vrijstaande woning" },
      { value: "GESCHAKELDE_WONING", text: "Geschakelde woning" },
      { value: "TWEE_ONDER_EEN_KAPWONING", text: "Twee onder een kapwoning" },
      { value: "TUSSENWONING", text: "Tussenwoning" },
      { value: "HOEKWONING", text: "Hoekwoning" },
      { value: "EINDWONING", text: "Eindwoning" },
      { value: "HALFVRIJSTAANDE_WONING", text: "Halfvrijstaande woning" },
      {
        value: "GESCHAKELDE TWEE ONDER EEN KAPWONING",
        text: "Geschakelde twee onder een kapwoning",
      },
      { value: "VERSPRINGEND", text: "Verspringend" },
    ],
    statusOptions: [
      { value: "PROSPECT", text: "Prospect" },
      { value: "IN_AANMELDING", text: "In aanmelding" },
      { value: "BESCHIKBAAR", text: "Beschikbaar" },
      { value: "ONDER_BOD", text: "Onder bod" },
      { value: "ONDER_OPTIE", text: "Onder optie" },
      { value: "VERKOCHT_ONDER_VOORBEHOUD", text: "Verkocht onder voorbehoud" },
      { value: "VERHUURD_ONDER_VOORBEHOUD", text: "Verhuurd onder voorbehoud" },
      { value: "VERKOCHT", text: "Verkocht" },
      { value: "VERHUURD", text: "Verhuurd" },
      { value: "GEVEILD", text: "Geveild" },
      { value: "INGETROKKEN", text: "Ingetrokken" },
      { value: "GEANNULEERD", text: "Geannuleerd" },
      { value: "VERKOCHT BIJ_INSCHRIJVING", text: "Verkocht bij inschrijving" },
    ],
    locatieOptions: [
      { value: "Amsterdam", text: "Eengezinswoning" },
      { value: "Rotterdam", text: "Herenhuis" },
      { value: "Utrecht", text: "Villa" },
      { value: "Groningen", text: "Landhuis" },
      { value: "Eindhoven", text: "Bungalow" },
      { value: "Hengelo", text: "Woonboerderij" },
      { value: "Maastricht", text: "Grachtenpand" },
      { value: "", text: "Woonboot" },
      { value: "Den Haag", text: "Stacaravan" },
      { value: "Zwolle", text: "Woonwagen" },
      { value: "Lelystad", text: "Landgoed" },
    ],

    servicesOptions: [
      { value: "Repair", text: "Eengezinswoning" },
      { value: "Renovatie", text: "Herenhuis" },
      { value: "Brandwerende Coating Aanbrengen", text: "Villa" },
      { value: "Inspectie", text: "Landhuis" },
    ],

    productGroepOptions: [
      { value: "Product1", text: "Eengezinswoning" },
      { value: "Product2", text: "Herenhuis" },
      { value: "Product3", text: "Villa" },
      { value: "Product4", text: "Landhuis" },
      { value: "Product5", text: "Bungalow" },
      { value: "Product6", text: "Woonboerderij" },
    ],

    branchOptions: [
      { value: "Mijnbouw", text: "Eengezinswoning" },
      { value: "Scheepsbouw", text: "Herenhuis" },
      { value: "Recreatie", text: "Villa" },
      { value: "Onderwijs", text: "Landhuis" },
      { value: "Overheid", text: "Bungalow" },
      { value: "Transport", text: "Woonboerderij" },
      { value: "Wetenschap", text: "Grachtenpand" },
    ],
  },
};
